import { useCallback, useMemo } from 'react';
import * as THREE from 'three';
import { type Transform } from './VisibilityBox';
import type { Number3 } from '../types';
import { isPointInsideCuboidMatrix, matrixFromCuboid } from './Util';

export const useIsPointInsideCuboid = (cuboid: Transform | undefined) => {
  const matrixInverse = useMemo(() => cuboid && matrixFromCuboid(cuboid).invert(), [cuboid]);

  const isPointInsideCuboid = useCallback(
    (point: Number3) => {
      const pointVec = new THREE.Vector3(...point);
      return !matrixInverse || isPointInsideCuboidMatrix(pointVec, matrixInverse);
    },
    [matrixInverse]
  );

  return isPointInsideCuboid;
};
